import { useEffect } from 'react'

import { initializeApp } from 'firebase/app'
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from 'firebase/messaging'
import { Link as RouterLink } from 'react-router-dom'

import { NotificationChannel } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import {
  useMemberNotificationSettings,
  useUpdateMemberNetworkNotificationSettings,
} from '@tribeplatform/react-sdk/hooks'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { toast, ToastComponent } from '@tribeplatform/react-ui-kit/Toast'

import { useLogin } from '../hooks/useLogin'

export const DesktopNotification = () => {
  const { isLoggedIn } = useLogin()
  const { mutate: updateMemberNetworkNotificationSettings } =
    useUpdateMemberNetworkNotificationSettings()
  const { data: notificationSettings } = useMemberNotificationSettings({
    fields: {
      network: 'basic',
    },
    useQueryOptions: {
      enabled: isLoggedIn,
    },
  })
  const networkDesktopNotificationSetting =
    notificationSettings?.network?.filter(
      n => n.channel === NotificationChannel.DESKTOP,
    )[0]

  useEffect(() => {
    if (!isLoggedIn) {
      return
    }
    if (!networkDesktopNotificationSetting?.enabled) {
      return
    }

    const firebaseConfig = {
      apiKey: 'AIzaSyAOg7DiR0iacQPO7jlix_6MgWe3JXhfGtg',
      authDomain: 'tribeplatform.firebaseapp.com',
      projectId: 'tribeplatform',
      storageBucket: 'tribeplatform.appspot.com',
      messagingSenderId: '1081893321319',
      appId: '1:1081893321319:web:baed5f30cea3272be9f2c2',
      measurementId: 'G-VQ1KRW18TJ',
    }
    const vapidKey =
      'BLxlLxenGuNYPnbQdGFuKxqCqDrMPWH_4A_dbi6pSCHBrdQs6NoTZE17ujuh90XK0kPolN_K0GHeqg6cnn8lRaM'

    try {
      initializeApp(firebaseConfig)

      const messaging = getMessaging()
      if (isSupported()) {
        onMessage(messaging, payload => {
          const {
            notification: { title, body, image },
            data: { url },
          } = payload

          toast({
            custom: ({ onClose }) => (
              <ToastComponent.Content
                icon={image ? <Avatar src={image} /> : undefined}
                title={title}
                description={body}
              >
                <div className="mt-3 flex space-s-7">
                  <Link as={RouterLink} to={url} onClick={onClose}>
                    <T
                      defaultMessage="View notification"
                      id="DesktopNotification.Action.View"
                    />
                  </Link>
                </div>
              </ToastComponent.Content>
            ),
          })
        })

        getToken(messaging, { vapidKey })
          .then(currentToken => {
            if (currentToken) {
              // logger.info('Device token', currentToken)
              updateMemberNetworkNotificationSettings({
                channel: NotificationChannel.DESKTOP,
                input: {
                  enabled: true,
                  options: {
                    fcmDeviceToken: currentToken,
                  },
                },
              })
            } else {
              logger.warn(
                'No registration token available. Request permission to generate one.',
              )
            }
          })
          .catch(err => {
            logger.error('An error occurred while retrieving token. ', err)
          })
      }
    } catch (e) {
      logger.error(
        'An error occurred while initializing desktop notifications. ',
        e,
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, networkDesktopNotificationSetting?.enabled])
  return null
}
